(function () {
    'use strict';

    angular.module("imApp").factory("webSiteNewService", ['$ihttp', function ($ihttp) {
        let service = {
            getWebSiteNew: function (parms) {
                return $ihttp.post({
                    method: 3029,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3030,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
